import { render } from "./BaseDropdown.vue?vue&type=template&id=0dacceaf&scoped=true"
import script from "./BaseDropdown.vue?vue&type=script&lang=js"
export * from "./BaseDropdown.vue?vue&type=script&lang=js"

import "./BaseDropdown.vue?vue&type=style&index=0&id=0dacceaf&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0dacceaf"

export default script